module.exports = __webpack_public_path__ + "img/loading.76c59853.gif";